import React, { useCallback, useMemo } from 'react'
import { Grid, makeStyles } from '@material-ui/core'
import DazzedParagraph14 from 'components/common/text/DazzedParagraph14'
import { useTranslation } from 'react-i18next'
import { conditionTypes, MIN_SCANS_COUNT } from 'consts/automatedActionConsts'
import ErrorMessage from 'components/common/text/ErrorMessage'

const useStyles = makeStyles(theme => ({
  alignerNumberInput: {
    outline: 'none',
    fontSize: 16,
    textAlign: 'center',
    height: 32,
    width: 80,
    border: 'none',
    borderBottom: ({ errorMessage }) => (errorMessage ? '1px solid red' : '1px solid var(--border-color-11)'),
    paddingLeft: 14
  }
}))

const PatientScanCountCondition = ({ onChange, params, errors = {} }) => {
  const errorMessage = useMemo(() => errors.conditions?.[conditionTypes.PatientScanCount], [errors])
  const classes = useStyles({ errorMessage })
  const { t } = useTranslation()

  const handleChange = useCallback(
    newNumber => {
      onChange({
        type: conditionTypes.PatientScanCount,
        params: {
          scansCount: newNumber
        }
      })
    },
    [onChange]
  )

  return (
    <Grid container direction="column">
      <Grid item>
        <Grid container alignItems="center">
          <Grid item>
            <DazzedParagraph14 strong>
              {t('pages.accountSettings.automations.editorModal.enterNumberOfScans')}
            </DazzedParagraph14>
          </Grid>
          <Grid item>
            <input
              id="automation-condition-scans-count"
              value={params?.scansCount || ''}
              type="number"
              inputMode="numeric"
              pattern="[0-9]*"
              placeholder={t('pages.accountSettings.automations.editorModal.enterNumberOfScansPlaceholder')}
              className={classes.alignerNumberInput}
              onChange={({ target }) => handleChange(target.value)}
              min={MIN_SCANS_COUNT}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item>{errorMessage && <ErrorMessage text={errorMessage} active={!!errorMessage} />}</Grid>
    </Grid>
  )
}
export default PatientScanCountCondition
